import type { Lens } from '@hookform/lenses';
import { z } from 'zod/v4';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { IxcRegistrationV1EmploymentPartTime } from '@interxfi/types/generated/api';
import { AppTextInputWithLens } from '../../../../../../components/form/app-text-input';

export const partTimeFormSchema = z.object({
  kind: z.literal('partTime'),
  value: z.object({
    institution: z.string().nonempty({ error: 'Institution is required' }),
    occupation: z.string().nonempty({ error: 'Occupation is required' }),
  }),
});

type PartTimeFormValues = z.infer<typeof partTimeFormSchema>;

export const defaultPartTimeFormValues: PartTimeFormValues = {
  kind: 'partTime',
  value: {
    institution: '',
    occupation: '',
  },
};

export function getInitialFormValuesForPartTime(data: IxcRegistrationV1EmploymentPartTime | undefined): PartTimeFormValues {
  return {
    ...defaultPartTimeFormValues,
    value: {
      institution: data?.institution ?? '',
      occupation: data?.occupation ?? '',
    },
  };
}

export function formValuesToPartTime(values: PartTimeFormValues): IxcRegistrationV1EmploymentPartTime {
  return {
    institution: values.value.institution.trim(),
    occupation: values.value.occupation.trim(),
  };
}

interface EmploymentPartTimeFormProps {
  lens: Lens<PartTimeFormValues>;
}

export function EmploymentPartTimeForm({ lens }: EmploymentPartTimeFormProps) {
  return (
    <VerticalStack gap={4}>
      <AppTextInputWithLens label="Occupation" lens={lens.focus('value.occupation')} required />
      <AppTextInputWithLens label="Institution" lens={lens.focus('value.institution')} required />
    </VerticalStack>
  );
}
